import styled from 'styled-components';
import {mobileMedia} from '../../../../../../../globalVariables/GlobalVariables';
import {dFlex, flexWrap} from '../../../../../../../globalVariables/GlobalFlex';

export const summaryRow = styled.div`
  ${dFlex}
  ${flexWrap}
  direction: ltr;
  gap: var(--space-lg);
  ${mobileMedia}{ flex-direction: column; }
`;
